import httpClient from "../../api/httpClient";

export const callAiRequestApi = async (payload) => {
  const { data } = await httpClient.post("ai-service", payload);
  return data;
};
